import * as v from "valibot";

import { rpcContract } from "../rpc";

export const updatePostRpcContract = rpcContract({
  name: "updatePost",
  paramsSchema: v.object({
    postId: v.string(),
    teaser: v.pipe(v.string(), v.minLength(1), v.maxLength(750)),
    worldIds: v.array(v.string()),
    newWorldNames: v.array(v.string()),
    brandIds: v.array(v.string()),
    ctaData: v.optional(
      v.object({
        callToAction: v.pipe(v.string(), v.minLength(1), v.maxLength(64)),
        url: v.pipe(v.string(), v.url()),
      }),
    ),
    discountData: v.optional(
      v.object({
        code: v.pipe(v.string(), v.minLength(1), v.maxLength(64)),
      }),
    ),
    faqBlocks: v.array(
      v.object({
        question: v.pipe(v.string(), v.minLength(1), v.maxLength(150)),
        answer: v.pipe(v.string(), v.minLength(1), v.maxLength(250)),
      }),
    ),
    fileId: v.optional(v.union([v.string(), v.literal("")])),
    startDate: v.optional(v.pipe(v.string(), v.isoDateTime())),
    cover: v.boolean(),
    contentTier: v.optional(v.picklist(["free", "premium"])),
    oneTimePriceCents: v.optional(v.pipe(v.number(), v.minValue(100), v.maxValue(99999))),
  }),
  resultSchema: v.object({
    postId: v.string(),
  }),
});

export type UpdatePostParams = v.InferOutput<(typeof updatePostRpcContract)["paramsSchema"]>;
export type UpdatePostResult = v.InferOutput<(typeof updatePostRpcContract)["resultSchema"]>;
